import { PropsWithChildren } from "react";
import { Box, ModalBody, Spinner } from "@chakra-ui/react";
import { RequestModal } from "components/RequestModals";

export const RequestProcessingModal = ({
  isOpen,
  children,
}: PropsWithChildren<{
  isOpen: boolean;
}>) => (
  <RequestModal isOpen={isOpen} canDismiss={false}>
    <ModalBody px={6} py={14}>
      <Box pb={4} textAlign="center">
        <Spinner
          color="navy.600"
          emptyColor="gray.200"
          size="lg"
          speed=".65s"
          thickness="3px"
        />
      </Box>
      {children}
    </ModalBody>
  </RequestModal>
);

export default RequestProcessingModal;
